import { createSelector } from 'reselect';

const supportedOriginSubdomains = {
  e0: ['localhost'],
  e1: ['-dev'],
  e2: ['-qa', 'e2qglobal', `qwww`],
};

const isEnvOrigin = (env, origin) => {
  if (typeof origin !== 'string') {
    return false;
  }

  return !!supportedOriginSubdomains[env].find((subDomain) =>
    origin.includes(subDomain)
  );
};

const getBrowserOrigin = (state) =>
  state.getIn(['browser', 'location', 'origin']);

export const getEnvLevel = createSelector(getBrowserOrigin, (origin) => {
  if (isEnvOrigin('e0', origin)) {
    return 'E0';
  }
  if (isEnvOrigin('e1', origin)) {
    return 'E1';
  }
  if (isEnvOrigin('e2', origin)) {
    return 'E2';
  }
  return 'E3';
});
